module.exports = __webpack_public_path__ + "media/images/testimonial-heyday-1fcb60308b8ae3cfb62d3d69607c67b3.svg";